import { Injectable } from '@angular/core';
import mediumZoom from 'medium-zoom';

@Injectable({
  providedIn: 'root'
})
export class ZoomImageService {
  private zoom: any;
  constructor() {
    this.zoom = mediumZoom(null, {
      margin: 24,
      background: 'rgba(0,0,0,.32)'
    });

    // A promise callback to handle overlay and zoomed image styling on opening of the zoomed image
    this.zoom.on('open', () => {
      setTimeout(() => {
        const overlay = document.querySelector('.medium-zoom-overlay') as HTMLElement;
        if (overlay) {
          overlay.classList.add('dls-zoomable-overlay');
        }
        const zoomedImage = document.querySelector('.medium-zoom-image--opened') as HTMLElement;
        if (zoomedImage) {
          zoomedImage.classList.remove('w-100');
          zoomedImage.classList.add('dls-zoomable-image');
        }
      }, 100);
    });
  }

  /**
   * Attaches the image as a native element to Medium Zoom
   * @param selectors: string[] | HTMLElement[] | NodeList[]
   * eg: attachImage('#image-1', '#image-2')
   * eg: attachImage(
   *    elementRef.nativeElement,
   *    document.querySelector('#image-3'),
   *    document.querySelectorAll('[data-zoomable]')
   *  )
   */
  attachImage(...selectors: string[] | HTMLElement[] | NodeList[]) {
    this.zoom.attach(selectors);
  }

  /**
   * Detaches specific image or list of images from Medium Zoom
   * @param selectors: string[] | HTMLElement[] | NodeList[]
   *
   * eg: detachImage(
   *    elementRef.nativeElement
   *    '#image-1',
   *     document.querySelector('#image-2')
   *  ) // detach multiple images
   */
  detachImage(...selectors: string[] | HTMLElement[] | NodeList[]) {
    this.zoom.detach(selectors);
  }

}
